import config from '_config';
import { fillRandomLetters } from '../index';
import { NormalStrategy, PercentageStrategy } from './strategies';
import { retryUnplacedWords } from './retry/RetryUnplacedWords';
import { WordState } from './state/WordState';

export default class WordHuntEngine {
  constructor(model, options = {}) {
    this.model = model;
    this.state = new WordState();
    this.maxInsertAttempts = 500;
    this.activeAlert = options.activeAlert || null;
    this.strategy = model.settings.enablePercentageDistribution
      ? new PercentageStrategy(this)
      : new NormalStrategy(this);
  }

  generate(game, wordsList, gameNumber = 1) {
    this.drawTable(game);

    this.strategy.place(wordsList, game);

    retryUnplacedWords(this, game, gameNumber);

    this.fillRandomLetters(game);
  }

  drawTable(game) {
    const { rows, columns } = this.model;

    game.table = [];

    for (let row = 0; row < rows; row += 1) {
      for (let col = 0; col < columns; col += 1) {
        game.table.push({
          positionx: row,
          positiony: col,
          text: '',
        });
      }
    }
  }

  fillRandomLetters(game) {
    game.table = fillRandomLetters(game.table, config.LOCALE);
  }
}
